import * as React from 'react';
import { useDispatch } from 'react-redux';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useTable } from '@app/components/table';
import { useRequestState, useDialog, useSearch } from '@app/hooks';
import { getDepartments } from '../slice';
import { selectDepartmentState } from '../selectors';
import { DepartmentList } from './department-list';
import { AddDepartment } from './add-department';
import { useAuthRolePermissions } from '@app/utils';

const DepartmentListPage = () => {
  const tableProps = useTable();

  const addDepartmentDialog = useDialog();

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getDepartments());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectDepartmentState,
    errorShown: true,
  });
  const searchProps = useSearch({ data: data?.records, fields: ['name', 'id'] });
  const { hasPermission } = useAuthRolePermissions();
  const canAddDepartment = hasPermission('Departments', 'w');

  return (
    <>
      <Header
        title={Strings.common.departments}
        helperText={''}
        actionButtonTitle={canAddDepartment ? Strings.common.addDepartment : undefined}
        onClickActionButton={addDepartmentDialog.show}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <DepartmentList
        loading={loading}
        tableProps={tableProps}
        rows={searchProps.filteredRows}
        canAddDepartment={canAddDepartment}
      />
      {addDepartmentDialog.visible && (
        <AddDepartment open={addDepartmentDialog.visible} onClose={addDepartmentDialog.hide} />
      )}
    </>
  );
};

export { DepartmentListPage };
